import type { FormInstance } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import { ProdutoTabVariacaoGrade } from './ProdutoTabVariacaoGrade';
import { ProdutoTabVariacaoVariacoes } from './ProdutoTabVariacaoVariacoes';

export function ProdutoTabVariacao({
    form,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    setFormDirty: (dirty: boolean) => void;
}) {
    return (
        <div className='flex flex-col gap-4'>
            <ProdutoTabVariacaoVariacoes form={form} setFormDirty={setFormDirty} />
            <ProdutoTabVariacaoGrade form={form} setFormDirty={setFormDirty} />
        </div>
    );
}
